import React from 'react';
import CrossRoad from "../UI/Crossroad";
import { tracksColors } from "../../config/styles";

const CrossRoad_16ARed_16BBlack = () => <CrossRoad coords="2379.000000, 407.000000" color={tracksColors.red}/>;

export default CrossRoad_16ARed_16BBlack;
